interface Props extends React.HTMLAttributes<HTMLImageElement>{ 
    className: string, 
    name?: string,
    path?: string 
}

export const Frame = ({ className, name, path, ...rest }: Props ) => {
    return (
        <>
            <img {...rest} className={`user-select-none frame ${className}`} src={path? path : `/img/frame/${name}.png`} alt="" onError={(e) => { e.currentTarget.style.display = "none"; }} />
        </>
    )
}